<template>
	<div>
    <div class="popup_high_right buy-number-list-popup"
         :class="['level-'+level,{}]">

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            Buy a new sending number
	            </h3>
<!--	            <span>* The prices are experimental and are set to be adjusted slightly in the near future.</span>-->

	            <div class="layout-column flex">

		            <div class="flex-none layout-column margin-b-20 margin-t-25">
			            <label class="margin-b-10">Country</label>
			            <select-field class="" :options="countries" label="text"
			                          @input="load()"
			                          small searchable append-to-body v-model="country"/>

<!--			            <input-field class="flex margin-t-25" style="padding-left: 10px" placeholder="Search by country name"-->
<!--			                         v-model="search" tabindex="0" small  :icon="require('@/assets/img/search_icon_gray.svg')"/>-->
		            </div>

		            <div class="layout-column margin-b-20" style="position: relative">
			            <Loading v-show="loading"/>

			            <table class="tariffs-table">
				            <thead>
				            <tr>
					            <td>Phone number</td>
					            <td>Monthly tariff</td>
					            <td></td>
				            </tr>
				            </thead>
				            <tbody>
				            <tr v-for="tariff in numbers" :key="tariff.phone_number">
					            <td class="number">+{{tariff.phone_number}}</td>
					            <td>${{parseFloat(tariff.monthly_tariff+'').toFixed(2)}}</td>
					            <td class="layout-column">
						            <v-button class="buy-btn" label="Buy" border slim
						                      @click="currentNumber=tariff; buyNumberOpen=true;"/>
					            </td>
				            </tr>
				            </tbody>
			            </table>
			            <div class="layout-row" v-if="!numbers || numbers.length===0">
				            <div class="flex"></div>
				            <p class="margin-t-25">No SMS enabled numbers available at the moment in <b>{{countryName}}</b>.</p>
				            <div class="flex"></div>
			            </div>
		            </div>
	            </div>

	            <div style="min-height: 10px"></div>
            </div>

	    <div class="popup-actions layout-row">
		    <v-button label="Close" border @click="$emit('close')" />
	    </div>


    </div>
		<popup-backdrop v-if="buyNumberOpen" @close="buyNumberOpen=false">
			<buy-number-popup :level="level+1" @close="buyNumberOpen=false" :number="currentNumber"
			                         @done="buyNumberOpen=false;$emit('done',$event)" :funnel-id="funnelId" />
		</popup-backdrop>
	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import VRadio from "@/components/base/v-radio";
import VSwitch from "@/components/base/v-switch";
import countries from "@/helpers/countries";
import BuyNumberPopup from "@/views/funnels/funnel-plus/funnel/sms_numbers/buy_number_popup"; // import syntax highlighting styles

export default {
	name: "buy-number-list-popup",
	mixins: [API],
	components: {
		BuyNumberPopup,
		VSwitch,
		VRadio,
		BackBtn,
		PopupBackdrop,
		SelectField,
		InputField,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnelId: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			saving: false,
			loading: false,
			search: "",
			numbers: [],
			countries: [
				{id:'US', text:'United States of America'},
				{id:'GB', text:'United Kingdom'},
				{id:'CA', text:'Canada'},
				{id:'AU', text:'Australia'},
				{id:'MX', text:'Mexico'},
				{id:'PT', text:'Portugal'},
				{id:'NL', text:'Netherlands'},
				{id:'RO', text:'Romania'},
				{id:'CZ', text:'Czech Republic'},
				// {id:'ID', text:'Indonesia'},
				{id:'SK', text:'Slovakia'},
				{id:'SE', text:'Sweden'},
				{id:'DK', text:'Denmark'},
			],
			country:'US',
			currentNumber: null,
			buyNumberOpen: false,
		}
	},
	computed:{
		countryName() {
			let c = this.countries.find(x=>x.id===this.country)
			return c ? ((['US','GB'].includes(c.id) ? 'The ' : '') + c.text) : '...';
		}
	},
	methods: {
		closePopup() {
			this.$emit('close')
		},
		//API
		async load() {
			try {
				this.loading = true;
				this.numbers = [];

				this.numbers = await this.api.sms.listAvailableNumbers(this.country);
			} catch (e) {
				this.$error(e);
			} finally {
				this.loading = false;
			}
		},
	},
	created() {
		this.load();
	},
}
</script>
<style lang="scss" scoped>
.buy-number-list-popup {
	padding: 0;
	.tariffs-table {
		border-collapse: collapse;
		border-spacing: 0;
		user-select: text;
		border: 1px solid $light-grey;
		border-radius: 3px;
		width: 100%;

		thead {
			tr td {
				border-bottom: 1px solid $light-grey;
				background: $light-silver;
				padding: 4px 6px;
				color: $dark-grey;
				font-weight: 500;
			}
		}
		tbody {
			tr td {
				padding: 5px 6px;
				//border-bottom: 1px solid $grey;
			}
			tr:nth-child(odd) {
				background: $light-silver;
			}
		}
		.buy-btn {
			margin: 4px auto;
		}
		.number {
			cursor: text;
			font-weight: 500;
		}
	}
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}
	.my-editor {
		font-family: Courier, monospace;
		font-size: 14px;
		line-height: 1.5;
		padding: 5px;
		//height: 25%;
		border-radius: 4px;
		border: 1px solid #ececec;
		background-color: whitesmoke;
		&.focused {
			border: 1px solid $blue;
		}
	}
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 3px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		svg {
			//color: #18d7ae;
			height: 18px;
			&.refund {
				color: $black;
			}
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
